//removeIf(production)
import ClaroluzEnergy from "./claroluz-energy";
//endRemoveIf(production)

class ClaroluzPower extends ClaroluzEnergy {
    public intervalDays: number;

    constructor({ value, price, intervalDays }: { value: number; price: number; intervalDays: number; }) {
        super({ value, price });
        this.intervalDays = intervalDays;
    }
}

//removeIf(production)
export default ClaroluzPower;
//endRemoveIf(production)